module.exports = __webpack_public_path__ + "static/media/trash.4dd03e8e.svg";